import React from 'react';
import isGenericLabel from 'utils/isGenericLabel';
import { Label } from '../Form.styles';
import { ResponseInputPropsType } from './Response';

const NoResponse = ({ data: { label } }: ResponseInputPropsType) =>
  label && !isGenericLabel(label) ? <Label>{label}</Label> : <div />;

export default NoResponse;
